import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ProcessLoading from "../components/processLoading";
import logo from "../assets/logo.png";
import "../styles/authentification.css";

const ResetPassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
  });

  const [modalState, setModalState] = useState({
    show: false,
    loading: false,
    success: false,
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Afficher le loading
    setModalState({
      show: true,
      loading: true,
      success: false,
      message: "Envoi de l'email de réinitialisation en cours...",
    });

    try {
      const response = await fetch("http://localhost:4000/api/client/forgot", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: formData.email,
        }),
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage || "Erreur lors de l'envoi de l'email");
      }

      //const data = await response.json();

      // Vérifier le Content-Type de la réponse
      const contentType = response.headers.get("content-type");
      let data;
      
      if (contentType && contentType.includes("application/json")) {
        // Si c'est du JSON, parser en JSON
        data = await response.json();
      } else {
        // Si c'est du texte brut, lire comme texte
        data = await response.text();
      }

      // Succès
      setModalState({
        show: true,
        loading: false,
        success: true,
        message: "Email de réinitialisation envoyé avec succès ! Vérifiez votre boîte mail.",
      });

      // Rediriger vers la page de vérification du token après 2 secondes
      setTimeout(() => {
        navigate("/verification", { state: { email: formData.email } });
      }, 2000);

    } catch (error) {
      console.error("Erreur:", error.message);
      setModalState({
        show: true,
        loading: false,
        success: false,
        message: `Erreur : ${error.message}`,
      });
    }
  };

  const closeModal = () => {
    setModalState((prev) => ({ ...prev, show: false }));
  };

  return (
    <div className="container-partenariat container-fluid p-0">
      <div className="row g-0 min-vh-100">
        {/* Section Gauche - Formulaire */}
        <div className="col-lg-6 d-flex align-items-center p-5 light-Mode">
          <div className="w-100">
            <Link to={"/"}>
              <FontAwesomeIcon icon={faArrowLeft} width={"50px"} />
            </Link>
            <h1
              className="mb-3"
              style={{ textAlign: "center", fontWeight: "lighter" }}
            >
              <strong style={{ color: "#0d6efd" }}>Mot</strong> de passe oublié
            </h1>
            <p className="text-center text-muted mb-4">
              Entrez votre adresse email pour recevoir un code de réinitialisation
            </p>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Adresse e-mail
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="exemple@email.com"
                  required
                />
              </div>
              <br />
              <button
                type="submit"
                className="btn w-100 py-3 mb-3 hover-primary"
                disabled={modalState.loading}
              >
                {modalState.loading ? "Envoi en cours..." : "Envoyer le code"}
              </button>

              <div className="text-center mt-3">
                <Link to="/" className="text-decoration-none">
                  Retour à la connexion
                </Link>
              </div>
            </form>
          </div>
        </div>

        {/* Section Droite */}
        <div className="col-lg-6 section-etude-cas">
          <div className="superposition-etude p-5 d-flex flex-column justify-content-between h-100">
            <div style={{ margin: "0 auto", marginTop: "40px" }}>
              <img
                src={logo}
                alt="logo transfo africa"
                style={{ width: "200px", height: "100px" }}
              />
            </div>
            <div>
              <blockquote className="citation mb-5" style={{ marginTop: "-20px" }}>
                <p className="mb-0 fs-3">
                  <strong style={{ color: "#0d6efd" }}>Transfo Africa</strong>{" "}
                  est une entreprise exerçant exclusivement dans le secteur des
                  nouvelles technologies de l'information. Nous vous proposons
                  des services tels que la sécurité des systèmes informatiques et
                  réseaux, le développement d'applications web et mobile et les
                  solutions cloud.
                </p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de chargement */}
      <ProcessLoading
        show={modalState.show}
        loading={modalState.loading}
        success={modalState.success}
        message={modalState.message}
        onClose={closeModal}
        autoCloseDelay={modalState.success ? 2000 : 3000}
        onAutoClose={closeModal}
      />
    </div>
  );
};

export default ResetPassword;
